module.exports = __webpack_public_path__ + "static/media/lady-godiva.3edf429c.gif";